import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import UseCaseIndex from "@/pages/UseCaseIndex";
import UseCaseDetail from "@/pages/UseCaseDetail";
import AuthPage from "@/pages/AuthPage";
import WorkspacePage from "@/pages/WorkspacePage";
import HistoryPage from "@/pages/HistoryPage";
import ReviewDetail from "@/pages/ReviewDetail";
import SettingsPage from "@/pages/SettingsPage";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="max-w-[900px] mx-auto p-10 text-ink-50 font-mono-plex text-sm uppercase tracking-widest">
        Loading…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

function AppShell() {
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/use-cases" element={<UseCaseIndex />} />
          <Route path="/use-cases/:key" element={<UseCaseDetail />} />
          <Route path="/workspace" element={<WorkspacePage />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/signup" element={<AuthPage mode="signup" />} />
          <Route
            path="/history"
            element={
              <Protected>
                <HistoryPage />
              </Protected>
            }
          />
          <Route
            path="/history/:id"
            element={
              <Protected>
                <ReviewDetail />
              </Protected>
            }
          />
          <Route
            path="/settings"
            element={
              <Protected>
                <SettingsPage />
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </BrowserRouter>
  );
}
